import * as C from '@/consts'
import component from '@/libs/component'

const Login = () => import(/* webpackChunkName: "login" */ './Login')

export default [
  {
    path: 'login',
    name: 'login',
    ...component(Login),
    meta: {
      type: C.PAGE_LOGIN
    }
  }
]
